import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { Modal } from 'ui-components/components/modal';
import { FlexColumn } from 'ui-components/components/flex';

import ModalPortal from '../../../../../../../components/modal-portal';
import { useAmountSummaryTable } from './use-edit-amount-summary';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';
import { EditAmountSummaryTable } from './edit-amount-summary-table';
import { EditAmountSummaryInstructions } from './edit-amount-summary-instructions';
import { ErrorBanner } from './edit-amount-summary-error-banner';

import messages from '../messages';
import style from './edit-amount-summary-modal.module.less';

export const EditAmountSummaryModal = ({ onClose, fulfillmentPlanId }) => {
  const salesOrderId = useSalesOrderIdContext();
  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow, saveAmountSummary, isError } =
    useAmountSummaryTable(salesOrderId);

  const onSave = useCallback(() => {
    saveAmountSummary(onClose);
  }, [saveAmountSummary, onClose]);

  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['edit-amount-summary-modal']} size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.editAmountsTitle} />
        </ModalHeader>
        <ModalBody className={style['edit-amount-summary-modal-content']}>
          <FlexColumn className={style['content-wrapper']}>
            <ErrorBanner isError={isError} />
            <EditAmountSummaryInstructions />
            <EditAmountSummaryTable
              getTableBodyProps={getTableBodyProps}
              getTableProps={getTableProps}
              headerGroups={headerGroups}
              prepareRow={prepareRow}
              rows={rows}
              selectedFulfillmentPlan={fulfillmentPlanId}
            />
          </FlexColumn>
        </ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton />
          <Button onClick={onSave} theme='primary'>
            <FormattedMessage {...messages.saveButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

EditAmountSummaryModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};
